module.exports = __webpack_public_path__ + "img/xk_3.86ed45e2.png";